import {Select} from "antd";
import React, {useEffect, useState} from "react";
import {getAllKhachHang} from "../../../../api/weightSlip";
import {vnNormalize} from "../common/vnNormalize";

const SelectContentKhachHangMobile = ({code, defaultValueKh, setDefaultValue}) => {

    const Option = Select
    const [options, setOptions] = useState([])

    useEffect(() => {
        getAllKhachHang(code, null).then(r => {
            setOptions(r)
        })
            .catch(() => {
            })
    }, [code])

    return (
        <div className={"pt-6 customer_select_mobile"}>
            <Select
                mode={"multiple"}
                maxTagCount={'responsive'}
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    vnNormalize(option.props.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                style={{width: "100%"}}
                value={defaultValueKh}
                onChange={(val)=>setDefaultValue(val)}
                placeholder={"Khách hàng"}
            >
                {options.map(p => <Option value={p}>{p}</Option>)}
            </Select>
        </div>
    )
}
export default SelectContentKhachHangMobile
